import { render, staticRenderFns } from "./ModalInfoList.vue?vue&type=template&id=73b112b4&scoped=true&"
import script from "./ModalInfoList.vue?vue&type=script&lang=js&"
export * from "./ModalInfoList.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoList.vue?vue&type=style&index=0&id=73b112b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b112b4",
  null
  
)

export default component.exports